<ng-template #Modal let-ref="modalRef">
  <form #ModalForm="ngForm">
    <nb-card *ngIf="translationReady" class="staffInfoTemplate" [nbSpinner]="info.IsLoding">
      <nb-card-header style="display: flex; justify-content: space-between; align-items: center;">
        {{ t('common_order_status_changed', '訂單狀態變更') }}
      </nb-card-header>

      <nb-card-body>
        <div class="row">
          <div class="row mx-0 col-sm-12 mt-2 justify-content-between">
            <label class="label col col-form-label text-nowrap">{{ t('report_detail_record', '詳細記錄') }}</label>
            <button nbButton style="margin-left: auto;" (click)="ShowDataMo.onOpen()">{{ t('common_view', '查看') }}</button>
            <div class="w-100 mt-2">
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>{{ t('common_operators', '操作人員') }}</th>
                    <th>{{ t('common_change_status', '變更狀態') }}</th>
                    <th>{{ t('common_update_time', '更新時間') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let status of statusHistory">
                    <td style="vertical-align: middle; max-width: 150px; word-wrap: break-word;">{{ status.CreateBy }}</td>
                    <td style="vertical-align: middle;">{{ status.statusName }}</td>
                    <td style="vertical-align: middle;">{{ status.CreateDate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="status-buttons">
          <div *ngFor="let status of statusList">
            <button nbButton [disabled]="!status.CanClick" (click)="onStatusClick(status.ID)">
              {{ status.statusName }}
            </button>
          </div>
        </div>
      </nb-card-body>
      <nb-card-footer>
        <button nbButton (click)="onClose()">{{ t('common_close', '關閉') }}</button>
      </nb-card-footer>
    </nb-card>
  </form>
</ng-template>

<!-- 彈窗 付款狀態-->
<app-show-data  #ShowDataMo_Tmp
  *ngIf="ShowDataMo.isShow"
  [EOSNo]="ShowDataMo.EOSNo"
  [source]="ShowDataMo.source"
  (emitClose)="ShowDataMo.onClose($event)">
</app-show-data>
